import ActionsForm from '@/shared/mixins/actionsForm'
import { toast, loading } from '@/shared/utils/UIHelper'
import MiscellaneousExpensesRepository from '@/shared/http/repositories/business/miscellaneousexpenses'
import Tools from '@/components/tools/Tools.js'
import AutocompleteZ from '@/components/forms/AutocompleteZ.vue'
// import {mask} from 'vue-the-mask'
import ExpenseMixin from '@/views/private/finance/expenses/travelexpensezpag/mixins/ExpenseMixin.js'
const name = 'CollaboratorTableTravelExpense'

export default {
  name,
  mixins: [ActionsForm, ExpenseMixin],
  components: {
    AutocompleteZ
  },

  props: { },

  updated () { },

  data () {
    return {
      ArrayPrimeiroAdiantamento: [],
      dataSearch: {}
    }
  },
  mounted () {
    this.Onload()
  },

  methods: {
    Onload (value) {
      this.dataSearch.EmpresaId = this.CompanySelected
      MiscellaneousExpensesRepository.GetPrimeiroAdiantamento(this.$refs.tableGridPrimeiroAdiantamentaDiverso.pagingLimit, this.$refs.tableGridPrimeiroAdiantamentaDiverso.pagingIndex, this.dataSearch)
        .then((Response) => {
          this.ArrayPrimeiroAdiantamento = Response.data.data
          this.$refs.tableGridPrimeiroAdiantamentaDiverso.LoadAllByData(Response)
          loading.close()
        })
        .catch((Error) => {
          loading.pop()
          toast.error('error!')
        })
    },
    formatMoney (value) {
      return Tools.formatMoney(value)
    },
    formataData (value) {
      if (value != null) {
        var data = new Date(value)
        var dia = data.getDate()
        var mes = data.getMonth() + 1
        var ano = data.getFullYear()
        var dataFormatada = dia.toString().padStart(2, '0') + '/' + mes.toString().padStart(2, '0') + '/' + ano
        return dataFormatada
      } else {
        return 'N/D'
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/views/private/miscellaneousreimbursement/components/FirstAdvanceMiscellaneous/FirstAdvanceMiscellaneous.js